import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { HealthStatus } from '@/__generated__/graphql';
import { toTitleCase } from '@/util/string';

export type HealthFilterDropdownProps = {};

export const HEALTH_FILTER_PARAM = 'health';

export const HealthFilterDropdown: FC<HealthFilterDropdownProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...Object.values(HealthStatus).map(
        (state): DropdownOption => ({ label: toTitleCase(state), value: state }),
      ),
    ],
    [],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const qsValue = searchParams.get(HEALTH_FILTER_PARAM) as HealthStatus | undefined;
    return options.find((o) => o.value === qsValue) || options[0];
  }, [searchParams, options]);

  return (
    <DropdownButton
      options={options}
      name={'Health:'}
      className="text-nowrap text-fgMain"
      listClassName="z-50"
      defaultOption={defaultOption}
      trackingId="explorer-health-filter"
      onChange={({ value }) => {
        if (typeof value !== 'string') return;
        if (value === 'all') {
          setSearchParams((p) => {
            p.delete(HEALTH_FILTER_PARAM);
            return p;
          });
        } else {
          setSearchParams((p) => {
            p.set(HEALTH_FILTER_PARAM, value);
            return p;
          });
        }
      }}
    />
  );
};
